import { ChangeDetectionStrategy, Component, input, model } from "@angular/core";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { FormsModule } from "@angular/forms";

@TypeManagerDecorator("s25-ng-payment-text-field")
@Component({
    selector: "s25-ng-payment-text-field",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule],
    template: `
        <textarea
            class="cn-form__control"
            rows="2"
            [attr.aria-label]="label()"
            [maxlength]="maxLength()"
            [disabled]="disabled()"
            [ngModel]="value()"
            (ngModelChange)="value.set($event)"
        ></textarea>
    `,
    styles: `
        :host {
            display: block;
        }

        textarea {
            width: 100%;
            min-width: 0;
            max-width: 100%;
            box-sizing: border-box;
            resize: vertical;
        }
    `,
})
export class S25PaymentTextFieldComponent {
    readonly value = model("");
    readonly label = input.required<string>();
    readonly maxLength = input(255);
    readonly disabled = input(false);
}
